jQuery(document).ready(function ($) {
  "use strict";

  // runTask([loadFeatureKeyword, loadRecentlyViewed]);
  
  $('.nav-search').on('click', function (e) { 
    e.preventDefault();   
    const modal = new bootstrap.Modal(document.getElementById('search'));
    modal.show();
  });



  let debounceTimer;
  $('.modal-search input[name="q"]').on('input', function () {
    const $input = $('.form-search input[name="q"]');
    const $btn = $('.btn-toggle-icon');
    const $iconSearch = $btn.find('.icon-search');
    const $iconClose = $btn.find('.icon-close');

    $('.result-wrap').show();
    $('.search-default').hide();
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      const search_input = $(this).val().trim();
      const noResultsMessage = noResultsTemplate.replace('__KEY__', search_input);
  
      if (search_input.length > 0) {
        // save featured api
        fetch(`${linkApp}/search`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            domain: domain,
            keyword: search_input
          })
        })
          .then(res => res.json())
          .then(data => {

          })
          .catch(err => console.error("Error logging search keyword:", err));


        const cachedData = localStorage.getItem(`search_${search_input}`);
        if (cachedData) {
          const data = JSON.parse(cachedData);
          renderSearchResults(data.resources.results.products, data.resources.results.collections,noResultsMessage);
          events();
        } else {
          fetch(`/search/suggest.json?q=${encodeURIComponent(search_input)}&resources[type]=product,collection&page=1&resources[limit]=4`)
            .then(response => response.json())
            .then(async data => {
              localStorage.setItem(`search_${search_input}`, JSON.stringify(data));
              renderSearchResults(data.resources.results.products, data.resources.results.collections,noResultsMessage);
              events();
            })
            .catch(error => {
              console.error("Error:", error);
            });
        }
      }
    }, 300);


    if ($(this).val().trim().length > 0) {
      $iconSearch.hide();
      $iconClose.show();
      $('.result-wrap').show();
      $('.search-default').hide();
    } else {
      $iconSearch.show();
      $iconClose.hide();
      $('.search-default').show();
      $('.result-wrap').hide();
    }

    $btn.on('click', function (e) {
      e.preventDefault();
      if ($iconClose.is(':visible')) {
        e.preventDefault();
        $input.val('').trigger('input');
        $input.focus();
        $('.search-default').show();
      } else {
        $('.result-wrap').hide();
      }
    });
  });

  function renderSearchResults(products, collections,noResultsMessage) {
    if (products && products.length) {
      const productHtmlList = products.map(async (item) => {
        const handle = item.handle;
        const url = `/products/${handle}?view=handle`;

        try {
          const productData = await $.get(url);
          const doc = new DOMParser().parseFromString(productData, 'text/html');
          const itemHtml = doc.querySelector('.card-product-handle');
          if (!itemHtml) return '';

          const desc = itemHtml.querySelector('.cartProduct__desc');
          const btncart = itemHtml.querySelector('.box-icon.addcart');
          if (desc) desc.remove();
          if (btncart) btncart.remove();

          return itemHtml.outerHTML;
          
        } catch (err) {
          console.error("Error loading product HTML:", err);
          return '';
        }
      });

      Promise.all(productHtmlList).then(productHtml => {
        if (productHtml.length === 0) {
          $('#search .result-product').removeClass('tf-grid-layout').empty().append(`<p class="text-result">${noResultsMessage}</p>`);
        } else {
          $('#search .result-product').addClass('tf-grid-layout').empty().append(productHtml.join(''));
          events();
        }
      });
    }
    else {
      $('.result-wrap .heading').hide();
      $('.result-wrap .search-tag').hide();
      $('#search .result-product').removeClass('tf-grid-layout').empty().append(`<p class="text-result">${noResultsMessage}</p>`);
    }

    Promise.all(productHtmlList).then(productHtml => {
      if (productHtml.length === 0) {
        $('.result-wrap .search-tag').hide();
        $('.result-wrap .heading').hide();
        $('#search .result-product').empty().append(`<p class="text-result">${noResultsMessage}</p>`);
      } else {
        $('.result-wrap .search-tag').show();
        $('.result-wrap .heading').show();
        $('#search .result-product').empty().append(productHtml.join(''));
        events();
      }
    });



    if (collections && collections.length) {
      const collectionHtmlList = collections.map(async (item) => {
        const title = item.title;
        const url = item.url;

        return `<a href="${url}" class="tag-link radius-60 link">${title}</a>`;
      });

      Promise.all(collectionHtmlList).then(collectionHtml => {
        if (collectionHtml.length === 0) {
           $('.result-wrap .search-tag').hide();
          $('#search .collection-product').empty().hide();
        } else {
          $('#search .collection-product').empty().append(collectionHtml.join('')).show();
          $('.result-wrap .search-tag').show();
        }
      });
    } else {
       $('.result-wrap .search-tag').hide();
      $('#search .collection-product').empty().hide();
    }

    $('.result-wrap').show();
  }



  // When the search button is clicked
  $('.modal-search button[type="submit"]').on('click', function () {
    const keyword = $('.modal-search input[name="text"]').val();
   

    // Send search log to server
    fetch(`${linkApp}/search`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        domain: domain,
        keyword: keyword
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          window.location = `/search?q=${keyword}`;
        } else {
          console.warn("Failed to log keyword:", data);
        }
      })
      .catch(err => console.error("Error logging search keyword:", err));

    return false;
  });

  // Load top feature keywords
  function loadFeatureKeyword() {
    $('.modal-search .list-tags').empty();
    $('#search .search-tag .loading').hide();
    fetch(`${linkApp}/top-keywords?domain=${domain}`)
      .then(res => res.json())
      .then(res => {
        $('#search .search-tag .loading').show();
        const container = document.querySelector('.modal-search .list-tags');
        if (!container || !Array.isArray(res.data)) return;

        container.innerHTML = res.data
          .map(keyword => `<a href="/search?q=${keyword}&type=product" class="tag-link radius-60 link">${keyword}</a>`)
          .join('');
        $('#search .search-tag .loading').hide();
      })
      .catch(err => {
        console.error("Error calling top-keywords API:", err);
        $('#search .search-tag .loading').hide();
        $('#search .search-tag .list-tags').append('<p class="no-products">Error API</p>');
      });
  }


  // Load recently viewed products
  function loadRecentlyViewed() {
    $('#search .recently-viewer .loading').hide();
    const dataUserStr = localStorage.getItem('dataUser');

    if (!dataUserStr) {
      console.warn("No dataUser found in localStorage");
      return;
    }

    let dataUser;
    try {
      dataUser = JSON.parse(dataUserStr);
    } catch (e) {
      console.error("Error parsing dataUser from localStorage:", e);
      return;
    }

    const userId = dataUser?.randomId;
    if (!userId) {
      console.warn("Missing randomId in dataUser");
      return;
    }

    $('#search .loadmore-item').empty();
    $('#search .view-more-button').hide();


    // Call API to get 10 most recently viewed products
    fetch(`${linkApp}/products-recent?user_id=${userId}&domain_name=${domain}&limit=4`)
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);

        }
        return res.json();
      })
      .then(async (data) => {
        $('#search .recently-viewer .loading').show();
        const items = data.data || [];
        if (!items.length) return;

        // Promise.all để chờ tất cả request hoàn thành
        const htmlList = await Promise.all(
          items.map(async (item) => {
            const handle = item.handle;
            const url = `/products/${handle}?view=handle`;

            try {
              const productData = await $.get(url);
              const doc = new DOMParser().parseFromString(productData, 'text/html');
              const itemHtml = doc.querySelector('.card-product-handle');
              if (!itemHtml) return '';

              // Xóa các thành phần không cần
              const desc = itemHtml.querySelector('.cartProduct__desc');
              const btncart = itemHtml.querySelector('.box-icon.addcart');
              if (desc) desc.remove();
              if (btncart) btncart.remove();

              return itemHtml.outerHTML;
            } catch (err) {
              console.error("Error loading product HTML:", err);
              return '';
            }
          })
        );

        // Append tất cả 1 lần
        $('#search .loadmore-item').append(htmlList.join(''));

        // Bind events sau khi render
        events();
        $('#search .recently-viewer .loading').hide();
        $('#search .view-more-button').show();
      })
      .catch(err => {
        console.error("Error calling recent views API:", err);
        const container = document.querySelector('.modal-search');
        $('#search .recently-viewer .loading').hide();
        $('#search .recently-viewer').append('<p class="no-products">Error API</p>');
      });
  }
  // Rebind product interaction events
  function events() {
    clickColors();
    addcart();
    compare();    
    S00601CartProduct.wishlist();
    S00601CartProduct.quickView();
    products.init();
  }
  events();

  // Handle add to cart
  function addcart() {
      $(document).off('click').on('click','#search .addcart, #search .btn-add-cart', function () {
        const modalElement = document.getElementById('search');
        const modalSearch = bootstrap.Modal.getInstance(modalElement);
        if (modalSearch) {
            modalSearch.hide(); 
        }

       

        var variantId = $(this).parents('.card-product').find('.colorItem.active').data('id');
        const quantity = 1;
        if (variantId == undefined)
          variantId = $(this).parents('.card-product').data('productid');

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            quantity: quantity,
            id: variantId
          },
          dataType: 'json',
          success: function () {
            fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                $('.nav-cart .icon-cart').next().remove();
                $('.nav-cart .icon-cart').after('<span class="count-box text-button-small">' + cart.item_count + '</span>');
                $('.open-cart').trigger('click');
                setTimeout(function () {
                  $('.tf-minicart-recommendations').addClass('open');
                }, 800);
              });
          },
          error: function (err) {
            alert('Add to cart failed.');
            console.error(err);
          }
        });
      });
    
  }

  // Handle compare product logic
  function compare() {
      $(document).off('click','#search .compare').on('click','#search .compare', function () {
        const modalElement = document.getElementById('search');
        const modalSearch = bootstrap.Modal.getInstance(modalElement);
        if (modalSearch) {
            modalSearch.hide(); 
        }

        // const $card = $(this).closest('.card-product');
        // const productId = $card.find('.colorItem.active').data('id') || $card.data('productid');
        // const img = $card.find('.colorItem.active').data('img') || $card.find('.image-wrap img:first').attr('src');
        // const url = $card.find('.image-wrap').attr('href') + (productId ? `?variant=${productId}` : '');
        
        // if (!productId) return;

        // let dataUser = JSON.parse(localStorage.getItem("dataUser") || '{}');

        // if (!dataUser.randomId) {
        //   dataUser = {
        //     id: typeof customerId !== "undefined" ? customerId : "",
        //     randomId: themeName + products.generateRandomString(100),
        //     dataWishlist: [],
        //     dataCompare: []
        //   };
        // }

        // const exists = dataUser.dataCompare?.some(item => item.id == productId);

        // if (exists) {
        //   // Remove from compare list
        //   dataUser.dataCompare = dataUser.dataCompare.filter(item => item.id != productId);
        //   $(`.tf-sidebar-compare .item[data-id="${productId}"]`).remove();
        //   $card.removeClass('compared');
        //   if (!$('.tf-sidebar-compare .item').length) $('.tf-sidebar-compare.active').removeClass('active');;
        // } else {
        //   // Add to compare list
        //   dataUser.dataCompare = [...(dataUser.dataCompare || []), { id: productId, img, url }];
        //   $('.tf-sidebar-compare .content').append(`
        //     <div class="item" data-id="${productId}">
        //       <span class="remove">
        //         <span class="icon icon-close"></span>
        //       </span>
        //       <a href="${url}" title=""><img src="${img}" alt=""></a>
        //     </div>`);
        //   $card.addClass('compared');
        //   $card.find('.box-icon.compare .icon_wrap').html('<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 48 48" width="24"><g fill="currentColor"><path d="m39 6h-9v-1a3 3 0 0 0 -3-3h-7a3 3 0 0 0 -3 3v1h-8a3 3 0 0 0 -3 3v2a3 3 0 0 0 2.025 2.824l.854 27.332a4.977 4.977 0 0 0 5 4.844h20.244a4.977 4.977 0 0 0 5-4.844l.854-27.332a3 3 0 0 0 2.023-2.824v-2a3 3 0 0 0 -3-3zm-20-1a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v1h-9zm18.122 36.094a2.987 2.987 0 0 1 -3 2.906h-20.245a2.987 2.987 0 0 1 -3-2.906l-.845-27.094h27.936zm2.878-30.094a1 1 0 0 1 -1 1h-30a1 1 0 0 1 -1-1v-2a1 1 0 0 1 1-1h30a1 1 0 0 1 1 1z"/><path d="m24 19a1 1 0 0 0 -1 1v18a1 1 0 0 0 2 0v-18a1 1 0 0 0 -1-1z"/><path d="m31.028 19a.972.972 0 0 0 -1.028.972l-.5 18a1 1 0 0 0 .972 1.028h.028a1 1 0 0 0 1-.972l.5-18a1 1 0 0 0 -.972-1.028z"/><path d="m16.972 19a1 1 0 0 0 -.972 1.028l.5 18a1 1 0 0 0 1 .972h.028a1 1 0 0 0 .972-1.028l-.5-18a1 1 0 0 0 -1.028-.972z"/></g></svg>');
        //   var tooltipDelete = $card.find('.box-icon.compare').data('tooltip-delete');
        //   $card.find('.box-icon.compare .tooltip').text(tooltipDelete);
        //   $('.tf-sidebar-compare').addClass('active');;
        // }

        // localStorage.setItem("dataUser", JSON.stringify(dataUser));
        S00801SidebarCompare.init(); // Initialize compare sidebar again
        S00601CartProduct.compare();
      });
  }

  // Color selector click event
  function clickColors() {
    $('#search .colorItem').each(function () {
      $(this).off('click').on('click', function () {
        $(this).addClass('active').siblings().removeClass('active');
        var _i = $(this).data('index');
        $('#search .cartProduct__prices .price').eq(_i).addClass('active').siblings().removeClass('active');
      });
    });
  }
});
